<template>
  <v-hover v-slot="{ hover }" open-delay="200">
    <v-card
      :loading="loading"
      class="mx-auto mt-5 rounded-xl"
      :class="{ 'on-hover': hover }"
      width="100%"
      :elevation="hover ? 16 : 2"
      style="border-radius: 20px !important"
    >
      <template slot="progress">
        <v-progress-linear
          color="deep-purple"
          height="10"
          indeterminate
        ></v-progress-linear>
      </template>

      <v-card-text class="pt-6">
        <v-row class="ma-0 pa-0 text-dark">
          <div style="width: 60px">
            <div class="text-h2 font-weight-bold" style="height: 40px">
              {{ formatDay }}
            </div>
            <div class="body-1 font-weight-bold text-warning">
              {{ formatMonth }}
            </div>
          </div>

          <v-col class="pa-0 ma-0">
            <div class="pl-0 mt-2">
              <div 
                class="font-weight-bold"
                :class="$vuetify.breakpoint.xs ? 'text-h6' : 'text-h5'"
                :style="{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: '-webkit-box',
                  WebkitLineClamp: $vuetify.breakpoint.xs ? 4 : 2,
                  WebkitBoxOrient: 'vertical',
                  lineHeight: '1.4',
                  wordBreak: 'break-word'
                }"
              >
                {{ item.event ? item.event.title : '' }}
              </div>
              <div class="body-1 font-weight-bold text-body mb-2 mt-1">
                {{ item.participant_data ? item.participant_data.name : '' }}
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="mx-4"></v-divider>

      <!-- QR Code Section -->
      <v-card-text class="pa-4">
        <div class="text-center mb-3">
          <div
            class="d-inline-block pa-3"
            style="
              background: #f7fafc;
              border-radius: 12px;
              border: 2px solid #e2e8f0;
            "
          >
            <qrcode-vue
              :margin="2"
              :value="item._id"
              :size="qrSize"
              level="H"
            ></qrcode-vue>
          </div>
        </div>

        <!-- Participant Address -->
        <div class="text-center mb-3" style="min-height: 48px;">
          <p v-if="item.participant_data && item.participant_data.street" class="text-body-2 text-body mb-0" style="color: #718096;">
            {{ item.participant_data.street }}
          </p>
          <p v-if="item.participant_data && (item.participant_data.zipcode || item.participant_data.city)" class="text-body-2 text-body mb-0" style="color: #718096;">
            {{ item.participant_data.zipcode ? item.participant_data.zipcode : '' }}{{ item.participant_data.zipcode && item.participant_data.city ? ', ' : '' }}{{ item.participant_data.city ? item.participant_data.city : '' }}
          </p>
        </div>

      </v-card-text>

      <!-- Ticket Status Footer -->
      <v-card-text
        class="pa-4 text-center white--text"
        :style="{
          backgroundColor: !item.status ? '#4caf50' : '#f44336',
          borderBottomLeftRadius: '20px',
          borderBottomRightRadius: '20px'
        }"
      >
        <div class="d-flex align-center justify-center">
          <i 
            v-if="!item.status" 
            class="material-icons-round mr-2" 
            style="font-size: 28px;"
          >
            check_circle
          </i>
          <i 
            v-else 
            class="material-icons-round mr-2" 
            style="font-size: 28px;"
          >
            cancel
          </i>
          <span class="text-h6 font-weight-bold">
            {{ item.status ? 'Eingelöst' : 'Gültig' }}
          </span>
        </div>
      </v-card-text>
    </v-card>
  </v-hover>
</template>

<script>
import QrcodeVue from "../../plugins/qrcode.vue";
import moment from "moment";
export default {
  name: "TicketCardQR",
  components: {
    QrcodeVue,
  },
  props: {
    item: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    formatMonth() {
      if (!this.item.event || !this.item.event.date) return "";
      return moment(this.item.event.date).format("MMMM").toUpperCase().slice(0, 3);
    },
    formatDay() {
      if (!this.item.event || !this.item.event.date) return "";
      return moment(this.item.event.date).format("DD");
    },
    qrSize() {
      // Responsive QR code size
      if (this.$vuetify.breakpoint.xs) {
        return 160;
      } else if (this.$vuetify.breakpoint.sm) {
        return 180;
      } else {
        return 200;
      }
    },
  },
  methods: {
    getImage(link) {
      return process.env.VUE_APP_API_BASEURL + "/" + link;
    },
  },
};
</script>

<style>
.v-card {
  transition: all 0.4s ease-in;
}
</style>
